import { useEffect } from "react";

interface MetaInput {
  title: string;
  description: string;
  keywords?: string;
}

function upsertMeta(name: string, attr: "name" | "property", content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaInput) {
  useEffect(() => {
    document.title = title;
    upsertMeta("description", "name", description);
    if (keywords) {
      upsertMeta("keywords", "name", keywords);
    }
    upsertMeta("og:title", "property", title);
    upsertMeta("og:description", "property", description);
  }, [title, description, keywords]);
}